export function generateAMOUrl(id: string) {
  return `https://appscience.amocrm.ru/leads/detail/${id}`
}
